var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircularLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 33,
    viewBox: "0 0 23 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.182 11.2987V8.04385C15.182 5.58602 13.3795 3.57498 11.1765 3.57498C8.97341 3.57498 7.17093 5.58595 7.17093 8.04385V11.2987H3.96654V8.04391C3.96654 3.61977 7.21102 0 11.1765 0C15.1419 0 18.3864 3.61977 18.3864 8.04391V11.2987H15.182ZM22.3529 15.7746V29.4934C22.3529 31.0302 21.2259 32.2876 19.8484 32.2876H2.50452C1.12703 32.2876 0 31.0302 0 29.4934V15.7745C0 14.2377 1.12703 12.9803 2.50452 12.9803H19.8484C21.2259 12.9803 22.3529 14.2377 22.3529 15.7746ZM13.2827 20.4893C13.2827 19.1915 12.3397 18.1394 11.1765 18.1394C10.0132 18.1394 9.07024 19.1915 9.07024 20.4893C9.07024 21.2878 9.42735 21.9932 9.97293 22.4178V25.7859C9.97293 26.5245 10.5145 27.1286 11.1765 27.1286C11.8385 27.1286 12.38 26.5244 12.38 25.7859V22.4177C12.9257 21.9931 13.2827 21.2877 13.2827 20.4893Z",
    fill: "#6B7DE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircularLock);
export default __webpack_public_path__ + "static/media/icon_circular_lock.576bcb10f358935023f0abb54a706551.svg";
export { ForwardRef as ReactComponent };